import InlineFAAS from './InlineFAAS'

export default InlineFAAS
